import React, { useState } from "react";
import CryptoJS from "crypto-js";
import { useNavigate } from 'react-router-dom';
import SchemesPage from "../Scheme/SchemesPage";
import SchemeForm from "../Scheme/SchemeForm";
import SchemeDetails from "../Scheme/SchemeDetails";

// file extension check regex
export const formatOFTicketRegex = /.(jpe?g|png)$/i;

function UserSchemes() {

  const navigate = useNavigate();

  const [formStep, setFormStep]= useState(1);
  const [schemeId, setSchemeId]= useState(null);
  const [activeScheme, setActiveScheme]= useState(null);

  const handleApply = (id) => {
    // console.log(id);
    goToStep(3, id);
  };

  const handleClickDetails = (id, category, scheme) => {
    // console.log(id);
    goToStep(2, id, scheme);
  };

    const goToStep = (step, schemeid = null, scheme) => {
      
      let secretKey = process.env.REACT_APP_SECRET_KEY ;
      let encryptedId = encodeURIComponent(CryptoJS.AES.encrypt(schemeid.toString(), secretKey).toString());
      
      if(step === 2){
        navigate(`/grant-scheme/description/${encryptedId}`, { state: { scheme: scheme } });
      }
      if(step === 3){
        navigate(`/grant-scheme/form/${encryptedId}`);
      }
    
      window.scrollTo({ top: 0, behavior: 'smooth' })
    };

  return (
    <>
      <div className="user-schemes-container">
        {formStep === 1?<SchemesPage onApply={handleApply} onClickDetails={handleClickDetails} changeActiveScheme={  (scheme)=>{setActiveScheme(scheme); localStorage.setItem("scheme",JSON.stringify(scheme));}} />
        :formStep === 2?<SchemeDetails schemeId={schemeId} onApply={handleApply} scheme={activeScheme} />
        :formStep === 3?<SchemeForm schemeId={schemeId} backToDashboard={()=>setFormStep(1)} />
        :<></>
        }
      </div>
    </>
  );
}

export default UserSchemes;
